import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Target, Eye, Users, Award } from "lucide-react";
import { useI18n } from "@/i18n/i18n";

export default function AboutSection() {
  const { tr } = useI18n();
  return (
    <section className="py-24 lg:py-32 border-y border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6">
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative rounded-[2rem] overflow-hidden border border-white/10 shadow-2xl shadow-blue-950/40"
          >
            <img
              src="https://images.pexels.com/photos/8101911/pexels-photo-8101911.jpeg?auto=compress&cs=tinysrgb&w=1400"
              alt={tr.about.title_em}
              className="w-full h-[520px] object-cover"
              data-testid="about-image"
            />
          </motion.div>
        </div>

        <div className="lg:col-span-6">
          <p className="overline text-[color:var(--mc-gold)]">{tr.about.overline}</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl font-semibold tracking-tight mt-4 leading-tight text-white">
            {tr.about.title_pre}{" "}
            <em className="not-italic italic bg-gradient-to-r from-[color:var(--mc-cyan-2)] to-[color:var(--mc-cyan)] bg-clip-text text-transparent">
              {tr.about.title_em}
            </em>
          </h2>
          <p className="mt-5 text-lg text-white/70 leading-relaxed">{tr.about.body}</p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div className="p-6 rounded-2xl border border-white/10 bg-white/[0.04]">
              <Target className="h-6 w-6 text-[color:var(--mc-cyan)]" />
              <p className="font-heading font-semibold mt-3 text-white">{tr.about.mission_title}</p>
              <p className="text-sm text-white/70 mt-2 leading-relaxed">{tr.about.mission_body}</p>
            </div>
            <div className="p-6 rounded-2xl border border-white/10 bg-white/[0.04]">
              <Eye className="h-6 w-6 text-[color:var(--mc-cyan)]" />
              <p className="font-heading font-semibold mt-3 text-white">{tr.about.vision_title}</p>
              <p className="text-sm text-white/70 mt-2 leading-relaxed">{tr.about.vision_body}</p>
            </div>
          </div>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-5">
            {tr.about.stats.map((s) => (
              <div key={s.label}>
                <p className="font-serif-display text-3xl sm:text-4xl font-semibold tracking-tight text-[color:var(--mc-gold)]">
                  {s.value}
                </p>
                <p className="text-xs text-white/55 mt-1 uppercase tracking-wider">{s.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 flex gap-3">
            <Link to="/nosotros" className="btn-primary" data-testid="about-cta-more">
              {tr.about.cta_more} <Users className="h-4 w-4" />
            </Link>
            <Link to="/contacto" className="btn-ghost" data-testid="about-cta-contact">
              {tr.about.cta_contact} <Award className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
